import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const PRIVACY_POLICY = `
# 智厨云隐私协议

**生效日期：2026年5月23日**

欢迎使用智厨云（以下简称"本平台"）。本协议适用于智厨云提供的所有产品和服务，包括但不限于网站（zchef.cn、admin.zchef.cn、enterprise.zchef.cn）及微信小程序。

## 一、信息收集

我们在您使用服务过程中可能收集以下信息：

### 1. 您主动提供的信息
- **注册信息**：手机号码、登录密码
- **企业信息**：企业名称、联系人姓名、联系电话、地址
- **订单信息**：收货地址、配送要求
- **支付信息**：支付方式选择

### 2. 我们自动收集的信息
- **设备信息**：设备型号、操作系统版本
- **位置信息**：用于考勤打卡、配送定位（需您授权）
- **日志信息**：访问时间、页面浏览记录

### 3. 相机/相册权限
- 用于上传头像、发票图片、收货确认照片等（仅在您主动使用相关功能时请求）

## 二、信息使用

我们收集的信息将用于：
1. 提供、维护和改善我们的服务
2. 处理您的订单和配送
3. 身份验证和账户安全
4. 客户服务与沟通
5. 防范欺诈和安全风险

## 三、信息共享

未经您的同意，我们不会向第三方共享您的个人信息，但以下情况除外：
1. 法律法规要求或政府主管部门依法要求
2. 与关联公司共享（仅限于提供服务所需）
3. 与服务提供商共享（如物流配送、支付服务）

## 四、信息存储与安全

- 我们采用行业标准的安全技术和管理措施保护您的信息
- 信息存储于中华人民共和国境内的服务器
- 数据保留期限：账户存续期间及注销后合理期限内

## 五、您的权利

您有权：
1. 访问和查询您的个人信息
2. 更正和修改您的个人信息
3. 删除您的个人信息（法律要求保留的除外）
4. 撤回授权同意
5. 注销账户

## 六、未成年人保护

我们不对未满14周岁的未成年人提供服务。如发现未成年人违规使用，我们将立即停止服务并删除相关信息。

## 七、协议变更

我们可能适时修订本协议。修订后的协议将在本页面发布，重大变更将通过站内通知或短信方式告知您。

## 八、联系方式

如您对本协议有任何疑问，请通过以下方式联系我们：

- **运营主体**：上海市闵行区智厨云食品店
- **客服热线**：021-88888888
- **备案号**：沪ICP备2026017961号
`

export default function PrivacyPolicy() {
  const navigate = useNavigate()

  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: '32px 24px', background: '#fff', minHeight: '100vh' }}>
      <div style={{ marginBottom: 24, display: 'flex', alignItems: 'center', gap: 12 }}>
        <a onClick={() => navigate(-1)} style={{ cursor: 'pointer', color: '#1890ff', fontSize: 14 }}>← 返回</a>
        <h1 style={{ margin: 0, fontSize: 22 }}>隐私协议</h1>
      </div>
      <div style={{ color: '#333', lineHeight: 2, fontSize: 14 }}>
        {PRIVACY_POLICY.split('\n').map((line: string, i: number) => {
          if (line.startsWith('# ')) return <h1 key={i} style={{ fontSize: 20, marginTop: 24 }}>{line.replace('# ', '')}</h1>
          if (line.startsWith('## ')) return <h2 key={i} style={{ fontSize: 17, marginTop: 20, marginBottom: 8 }}>{line.replace('## ', '')}</h2>
          if (line.startsWith('### ')) return <h3 key={i} style={{ fontSize: 15, marginTop: 16 }}>{line.replace('### ', '')}</h3>
          if (line.startsWith('- ')) return <div key={i} style={{ paddingLeft: 16 }}>• {line.replace('- ', '')}</div>
          if (line.trim() === '') return <br key={i} />
          return <p key={i} style={{ margin: '4px 0' }}>{line}</p>
        })}
      </div>
    </div>
  )
}
